import { render, staticRenderFns } from "./CurrentTermSummary.vue?vue&type=template&id=35ee52f4&scoped=true&"
import script from "./CurrentTermSummary.vue?vue&type=script&lang=js&"
export * from "./CurrentTermSummary.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTermSummary.vue?vue&type=style&index=0&id=35ee52f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee52f4",
  null
  
)

export default component.exports